module.exports = __webpack_public_path__ + "static/media/creek.aff0da91.png";